import { NavLink, useNavigate } from 'react-router-dom';
import { ClipboardList, Images, LayoutDashboard, LogOut } from 'lucide-react';

import { clearSession, getUser } from '../utils/auth';
import '../styles/layout.css';

export default function Layout({ children }) {
  const navigate = useNavigate();
  const user = getUser();

  const handleLogout = () => {
    clearSession();
    navigate('/login', { replace: true });
  };

  const userName = user
    ? `${user.prenom || user.firstname || ''} ${user.nom || user.lastname || ''}`.trim()
    : 'Client';

  const role = user?.role || 'client';

  return (
    <div className="app-layout">
      <aside className="sidebar">
        <div className="sidebar-header">
          <div className="sidebar-logo-box">
            <img
              src="/assets/logo.png"
              alt="Tunisie Telecom"
              className="sidebar-logo"
            />
          </div>

          <div>
            <h2>Tunisie Telecom</h2>
            <p>Espace Client</p>
          </div>
        </div>

        <nav className="sidebar-menu">
          <NavLink
            to="/dashboard"
            className={({ isActive }) =>
              isActive ? 'sidebar-link active' : 'sidebar-link'
            }
          >
            <LayoutDashboard size={20} />
            <span>Dashboard</span>
          </NavLink>

          {(role === 'client' || role === 'admin') && (
            <NavLink
              to="/brandings"
              className={({ isActive }) =>
                isActive ? 'sidebar-link active' : 'sidebar-link'
              }
            >
              <Images size={20} />
              <span>Consulter branding</span>
            </NavLink>
          )}

          {(role === 'merch' || role === 'admin') && (
            <NavLink
              to="/merch-brandings"
              className={({ isActive }) =>
                isActive ? 'sidebar-link active' : 'sidebar-link'
              }
            >
              <ClipboardList size={20} />
              <span>Visites Merch</span>
            </NavLink>
          )}
        </nav>

        <div className="sidebar-footer">
          <div className="sidebar-user">
            <div className="sidebar-user-avatar">
              {userName?.charAt(0)?.toUpperCase() || 'C'}
            </div>

            <div>
              <strong>{userName || 'Client'}</strong>
              <span>{user?.role || 'client'}</span>
            </div>
          </div>

          <button className="logout-button" onClick={handleLogout}>
            <LogOut size={19} />
            <span>Se déconnecter</span>
          </button>
        </div>
      </aside>

      <main className="main-content">
        {children}
      </main>
    </div>
  );
}